import { render, staticRenderFns } from "./c_Creator_EditQuests_Item_BodyMapRiddles.vue?vue&type=template&id=0b5cf17e&scoped=true&"
import script from "./c_Creator_EditQuests_Item_BodyMapRiddles.vue?vue&type=script&lang=js&"
export * from "./c_Creator_EditQuests_Item_BodyMapRiddles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5cf17e",
  null
  
)

export default component.exports